import { CancelToken } from 'axios';
import { agpAxiosClient } from './ABHubTokenConfig';
import {
    DRIItem,
    DRIItemGetResponse,
    DRIItemPutResponse,
} from '../../models/DRIItem';

export const getDRIItems = async (
    cancelToken?: CancelToken
): Promise<DRIItem[]> => {
    const response = await agpAxiosClient.get<DRIItemGetResponse>(
        `api/driitem`,
        { cancelToken }
    );
    return response.data.data;
};

export const setDRIItem = async (
    driItem: DRIItem,
    cancelToken?: CancelToken
): Promise<DRIItem> => {
    const response = await agpAxiosClient.put<DRIItemPutResponse>(
        `api/driitem`,
        driItem
    );
    return response.data.data;
};

export const deleteDRIItem = async (
    id: string,
    cancelToken?: CancelToken
): Promise<boolean> => {
    const response = await agpAxiosClient.delete(`api/driitem/${id}`);
    return response.data.data;
};
